import { render, staticRenderFns } from "./AdditiveModal.vue?vue&type=template&id=96d923a8&scoped=true&"
import script from "./AdditiveModal.vue?vue&type=script&lang=js&"
export * from "./AdditiveModal.vue?vue&type=script&lang=js&"
import style0 from "./AdditiveModal.vue?vue&type=style&index=0&id=96d923a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d923a8",
  null
  
)

export default component.exports